import React from "react";
import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import HttpMethods from "../../enums/api/http-methods";

export const httpMethodsToBackgroundColor = new Map([
    [HttpMethods.DELETE, "#F93E3E"],
    [HttpMethods.GET, "#61AFFE"],
    [HttpMethods.PATCH, "#50E3C2"],
    [HttpMethods.POST, "#49CC90"],
    [HttpMethods.PUT, "#FCA130"],
    [HttpMethods.HEAD, grey[500]],
    [HttpMethods.OPTIONS, grey[500]],
    [HttpMethods.TRACE, grey[500]],
]);

const HttpMethodChip: React.FC<{ httpMethod: HttpMethods }> = ({ httpMethod }) => {
    return (
        <Box
            sx={{
                px: 1,
                py: 0.25,
                borderRadius: 1,
                background: httpMethodsToBackgroundColor.get(httpMethod),
                fontWeight: "bold",
                textShadow: "0 1px 0 rgba(0,0,0,.1)",
                color: "#FFFFFF",
            }}
        >
            {httpMethod.toUpperCase()}
        </Box>
    );
};

export default HttpMethodChip;
